<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h5>Необходимо подтвердить Ваш email</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
          <p>На адрес {{ $store.getters.getUserData.email }} отправлено письмо. Пожалуйста, перейдите по содержащейся в нём ссылке для подтверждения своего аккаунта.</p>
        <form novalidate>
          <div class="form-group">
            <button class="btn btn-outline-info" type="button" disabled v-if="showTimeout">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                повторить через {{ timeoutSendCode }} сек.
            </button>
            <template v-else>
              <button class="btn btn-info" type="button" disabled v-if="showWaitCode">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Загрузка...
              </button>
              <button type="button" class="btn btn-outline-info" @click="sendCode" v-else>Отправить письмо повторно</button>
            </template>
          </div>

          <!--
          <button type="submit" class="btn btn-primary">
            Завершить регистрацию
          </button>
          -->

          <div class="form-group mt-3">
            <router-link :to="{ name: 'Login' }" class="d-inline" > Войти </router-link> | 
            <router-link :to="{ name: 'Registration' }" class="d-inline" > Регистрация </router-link>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      showWaitCode: false,
      timeoutSendCode: 300,
      showTimeout: '',
      userCode: '',
      codeError: {
        minLength: false,
        wrongCode: false,
      },
    }
  },
  methods: {
    startTimer() {
      this.showTimeout = true;
      const interval = setInterval(()=> {
        this.showTimeout = true;
        this.timeoutSendCode--;

        if (this.timeoutSendCode === 0) {
          clearInterval(interval);
          this.timeoutSendCode = 30;
          this.showTimeout = false;
        }
      }, 1000);
    },
    sendCode() {
      this.showWaitCode = true

      this.$store.dispatch('sendConfirmEmailLetter')
      .then(() => {
        this.showWaitCode = false
        this.startTimer()
      })
      .catch(() => {
        this.showWaitCode = false
      })
    },
  }
}
</script>
